<template>
  <div class="ins-kpis"><slot></slot></div>
</template>

<script>
/* Thin flex-wrap container for KPI / overview cards. Report supplies any number of cards. */
export default { name: "InsKpiGrid" };
</script>
